/**
 * Created by pajicv on 10/2/18.
 */
import React from 'react';
import Spinner from 'react-spinkit';
import {MAIN_COLOR} from '../../firebase-config';
//import {CircularProgress} from '@material-ui/core';

const LoadingProgress = () => (
  <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      height: '60%',
      width: '100%'
  }}>
    <Spinner style={{ width: 50, height: 50 }} name="circle" color={MAIN_COLOR} />
  </div>
);

export default LoadingProgress;



// WEBPACK FOOTER //
// ./src/components/common/LoadingProgress.js